// import React from 'react';
import logo from './assets/logo.svg';

export default logo;
